import React from 'react';
import Chart from 'react-apexcharts';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useSelector } from 'react-redux';
import useAuth from '../../../features/hooks/useAuth'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import UserDashboard from './UserDashboard';
import BoDashboard from './BoDashboard';
import UnitHeadDashboard from './UnitHeadDashboard';
import StoreManDashboard from './StoreManDashboard';
import { Modal, Card } from '@mui/material';


const ChartsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px; /* This will add gaps both vertically and horizontally */
`
const SingleWrapper = styled.div`
  border: 1px solid #36a8d9;
  border-radius: 10px;
  width: 23%;
`
const TextHeading = styled.h3`
  text-align: center;
`


const chartsData = [
  { type: 'pie', title: 'Asset Distribution', series: [44, 55, 13, 43], labels: ['IT', 'Furniture', 'Vehicles', 'Other'] },
  { type: 'bar', title: 'Assets by Department', series: [{ data: [10, 20, 15, 30] }], labels: ['HR', 'IT', 'Admin', 'Sales'] },
  { type: 'line', title: 'Procurement Over Time', series: [{ data: [100, 200, 150, 300] }], labels: ['Q1', 'Q2', 'Q3', 'Q4'] },
  { type: 'area', title: 'Stock Levels', series: [{ data: [20, 40, 35, 50] }], labels: ['Jan', 'Feb', 'Mar', 'Apr'] },
  { type: 'radialBar', title: 'Maintenance Status', series: [70], labels: ['Completed'] },
  { type: 'scatter', title: 'Issuance Trends', series: [{ data: [[10, 20], [30, 40], [50, 60]] }], labels: ['Dept1', 'Dept2', 'Dept3'] },
  { type: 'heatmap', title: 'Office Utilization', series: [{ data: [10, 20, 30, 40] }], labels: ['Office1', 'Office2', 'Office3', 'Office4'] },
  { type: 'donut', title: 'Asset Condition', series: [30, 50, 20], labels: ['Good', 'Average', 'Poor'] }
];

const Dashboard  = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeChart, setActiveChart] = useState(null);

  const handleChartClick = (chart) => {
    setActiveChart(chart);
    setModalOpen(true);
  };

  return (
    <ChartsWrapper>
      {chartsData.map((chart, index) => (
        <SingleWrapper key={index} onClick={() => handleChartClick(chart)}>
          <TextHeading>{chart.title}</TextHeading>
          <Chart
            options={{ labels: chart.labels, chart: { type: chart.type } }}
            series={chart.series}
            type={chart.type}
            height={150}
          />
        </SingleWrapper>
      ))}

      {modalOpen && activeChart && (
        <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <div className='p-4 bg-white rounded-lg shadow-lg m-auto w-3/4 h-3/4 flex flex-col items-center justify-center'>
            <h2 className='text-2xl mb-4'>{activeChart.title}</h2>
            <Chart
              options={{ labels: activeChart.labels, chart: { type: activeChart.type } }}
              series={activeChart.series}
              type={activeChart.type}
              height={400}
            />
          </div>
        </Modal>
      )}
    </ChartsWrapper>
  );
};







// const Container = styled.div``
// const Wrapper = styled.div``
// const SelectContainer = styled.div`
// display: flex;
// align-items: center;
// margin-bottom: 30px;
// margin-left: 20px;
// `

// const Dashboard = () => {
//   const [selcetedDash, setSelectedDash] = useState('user')
//   // logged in user info
//   const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
//   let user_current_office = (useSelector((state) => state.office.off))
//   let user_current_role_array = roles[user_current_office]

//   // except user other roles array
//   let staticRolesArray = ['Bo', 'UnitHead', 'level1approver', 'level2approver']

//   const contains = staticRolesArray.some(element => {
//     return user_current_role_array?.includes(element);
//   });

//   let options = []
//   if (user_current_role_array.includes('Bo')) {
//     options = ['user', 'Bo']
//   } else if (user_current_role_array.includes('UnitHead')) {
//     options = ['user', 'UnitHead']
//   } else if (user_current_role_array.includes('level1approver') || user_current_role_array.includes('level1approver')) {
//     options = ['user', 'storeMan']
//   } 

//   return (
//     <Container>
//       {contains && <SelectContainer>
//         <Autocomplete
//           id="combo-box-demo"
//           options={options}
//           sx={{ width: 600 }}
//           value={selcetedDash}
//           onChange={(event, newValue) => {
//             setSelectedDash(newValue);
//           }}
//           renderInput={(params) => <TextField {...params} label="Please Select Request Category" />}
//         />
//       </SelectContainer>}
//       <Wrapper>
//         {(!contains|| selcetedDash==='user' ) && <UserDashboard />}
//         {selcetedDash === 'Bo' && <BoDashboard />}
//         {selcetedDash === 'UnitHead' && <UnitHeadDashboard />}
//         {selcetedDash === 'storeMan' && <StoreManDashboard />}
//       </Wrapper>
//     </Container>

//   )

// }

export default Dashboard;
